import Component from 'vue-class-component';
import { Mixins } from 'vue-property-decorator';

import DesignerElementsMixin from '../../designer-elements.mixin';

@Component({
  name: 'ed-designer-rectangle',
})
export default class EdDesignerRectangleComponent extends Mixins(DesignerElementsMixin) {
  get rectangleStyles() {
    return {
      backgroundColor: this.value.meta?.backgroundColor,
    }
  }
}